import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52cab2a5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=52cab2a5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cab2a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52cab2a5')) {
      api.createRecord('52cab2a5', component.options)
    } else {
      api.reload('52cab2a5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52cab2a5&scoped=true", function () {
      api.rerender('52cab2a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/temporary/temporaryYet/index.vue"
export default component.exports